module.exports = __webpack_public_path__ + "static/media/home-002.49431d1b.jpg";